import { useEffect, useState } from 'react';
import './SectorForm.css';
import Panel from 'Components/Panel/Panel';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import SectorList from '../SectorList/SectorList';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';

const SectorForm = ({
    idsSectorCheckBoxSelected,
    onUpdateResetFilterSectorsSelected,
    resetFilterSectorsSelected,
    onUpdateIdsSectorCheckBoxSelected,
    sectorsLoadedFilter,
    sectorFilterSelected
}) => {
    const [sectorIdSelected, setSectorIdSelected] = useState();
    const [sectorNameSelected, setSectorNameSelected] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);

    const [attributeListSectorForm, setAttributeListSectorForm] = useState();
    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)

    const attributeList = [
        { name: "id", value: sectorIdSelected, setter: setSectorIdSelected },
        { name: "sector", value: sectorNameSelected, setter: setSectorNameSelected },
        { name: "phoneNumber", value: phoneNumber, setter: setPhoneNumber },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate }
    ];


    const fetchDataSectorForm = async (idSectorCheckBoxSelected) => {
        const parameters = { sectorId: idSectorCheckBoxSelected }
        const sectorInformation = await ExecuteAxios.api('get', `/sector/`, { params: parameters });
        setAttributeListSectorForm(sectorInformation)
        if (sectorInformation) {
            ApplyAttributes.applyAttributes(sectorInformation, attributeList)
        }
    };

    useEffect(() => {
        if (idsSectorCheckBoxSelected && idsSectorCheckBoxSelected.length === 1) {
            fetchDataSectorForm(idsSectorCheckBoxSelected[0]);
        } else {
            cleanVariablesSectorForm();
            fetchDataSectorForm(null);

        }
    }, [idsSectorCheckBoxSelected, inserting, updating]);

    useEffect(() => {
        if (resetFilterSectorsSelected) {
            cleanVariablesSectorForm();
        }
    }, [resetFilterSectorsSelected]);

    useEffect(() => {
        setInserting(false);
        setUpdating(false);
    }, [sectorFilterSelected]);

    function cleanVariablesSectorForm() {
        setSectorIdSelected('');
        setPhoneNumber('');
    }

    async function postSectorForm() {
        try {
            return await ExecuteAxios.api('post', `/sector/`, {
                sector: sectorNameSelected,
                phoneNumber: phoneNumber
            });
        } finally {
            onUpdateResetFilterSectorsSelected(true);
        }
    }

    async function putSectorForm() {
        return await ExecuteAxios.api('put', `/sector/`, {
            id: idsSectorCheckBoxSelected[0],
            sector: sectorNameSelected,
            phoneNumber: phoneNumber
        });
    }

    function cancelInserOrUpdating() {
        setUpdating(false);
        setInserting(false);
    }

    const handlePhoneChange = (event) => {
        let value = event.replace(/\D/g, '');

        if (value.length > 2) {
            value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
        }

        if (value.length > 9) {
            value = `${value.substring(0, 10)}-${value.substring(10)}`;
        }

        setPhoneNumber(value);
    };

    const sectorPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        borderBottom: '2px solid #ccc',
        width: '100%',
        height: '100%'
    };

    const readOnlyAttributes = !(inserting || updating);

    const deleteSectorId = async () => {
        const parameters = { sectorId: idsSectorCheckBoxSelected[0] }
        const response = await ExecuteAxios.api('delete', `/sector/`, { params: parameters });

        if (response) {
            onUpdateResetFilterSectorsSelected(true);
        }
        return response
    }

    return (
        <>
            <Panel style={sectorPanelStyle}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={idsSectorCheckBoxSelected.length === 1}
                putFunction={putSectorForm}
                enableNewRecord={true}
                canNewRecord={true}
                postFunction={postSectorForm}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={idsSectorCheckBoxSelected}
                viewOnlyOneRecordCRUD={true}
                titlePage='Setores'
                canDelete={true}
                enableDelete={idsSectorCheckBoxSelected.length === 1}
                deleteFunction={deleteSectorId}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributeListSectorForm}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateIdsSectorCheckBoxSelected}
            >
                <Panel style={{ height: '100%' }}>
                    {inserting || updating ?
                        <AutomaticallyListedAttributes
                            list={attributeListSectorForm}
                            attributeList={attributeList}
                            readOnlyAttributes={readOnlyAttributes}
                        />
                        :
                        <SectorList
                            onUpdateIdsSectorCheckBoxSelected={onUpdateIdsSectorCheckBoxSelected}
                            idsSectorCheckBoxSelected={idsSectorCheckBoxSelected}
                            sectorsLoadedFilter={sectorsLoadedFilter}
                        />
                    }
                </Panel>
            </Panel>
        </>
    );
};

export default SectorForm;